import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IAnnotationTemplate } from "@formant/core/model/IAnnotationTemplate";

import { annotationTemplateStore, appStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    annotationTemplate: IAnnotationTemplate;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Delete annotation"
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { annotationTemplate } = this.props;
        const { name, id } = annotationTemplate;
        const message = `Delete annotation "${name}"?`;
        appStore.setConfirm({
            title: "Delete annotation",
            message,
            onOk: async () => {
                await annotationTemplateStore.disable(defined(id));
                appStore.setSnackbar("Annotation deleted");
            },
        });
    };
}
